export default __webpack_public_path__ + "static/media/18t.fdc577a4.jpg";